import React from 'react';
import PreOrderForm from './components/PreOrderForm';

const App: React.FC = () => {
	return (
		<div className="App">
			<PreOrderForm />
		</div>
	);
};

export default App;
